import * as React from 'react'
import { SVGProps } from 'react'
const SvgCopy = (props: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={17} viewBox="0 0 14 17" fill="none" {...props}>
    <path
      d="M4.615 14c-.46 0-.844-.154-1.153-.463A1.565 1.565 0 0 1 3 12.384V1.616c0-.46.154-.845.462-1.154A1.565 1.565 0 0 1 4.615 0h7.77c.46 0 .844.154 1.152.463.309.308.463.692.463 1.153v10.768c0 .46-.154.845-.463 1.153a1.565 1.565 0 0 1-1.153.463H4.615Zm0-1h7.77a.588.588 0 0 0 .423-.192.588.588 0 0 0 .192-.424V1.616a.588.588 0 0 0-.192-.424.588.588 0 0 0-.424-.192H4.615a.588.588 0 0 0-.423.192.588.588 0 0 0-.192.423v10.77c0 .154.064.295.192.423s.27.192.423.192Zm-3 4c-.46 0-.844-.154-1.153-.462A1.564 1.564 0 0 1 0 15.385V3.615h1v11.77c0 .154.064.295.192.423s.27.192.423.192h8.77v1h-8.77Z"
      fill="#FAF6F0"
    />
  </svg>
)
export default SvgCopy
